<template>
    <div>
        <modal
            :is-open="isOpen"
            :is-loading="loading"
            :disabled="loading"
            :title="
                productIds.length === 1
                    ? 'Установить видимость изделия'
                    : 'Установите видимость изделий'
            "
            @onCloseModal="closeModal"
            @onSaveModal="saveModal"
        >
            <div v-if="productIds.length > 1">
                Выбрано изделий: {{ productIds.length }}
            </div>

            <product-visibility
                :visibility="initialVisibitily"
                @onChange="onProductVisibilityChange($event)"
            />
        </modal>
    </div>
</template>

<script>
import Modal from '@/components/Elements/Modal'
import ProductVisibility from '@/components/Cabinet/Supplier/Product/ProductVisibility'

import { mapActions, mapGetters } from 'vuex'

export default {
    name: 'ChangeVisibilityMass',
    components: { Modal, ProductVisibility },
    props: {
        productIds: {
            type: Array,
            required: true
        },
        isOpen: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            visibility: 0,
            loading: false
        }
    },
    computed: {
        ...mapGetters('supplierProducts', ['getProductKeyValue']),
        initialVisibitily() {
            if (this.productIds.length !== 1) return 0
            let access = this.getProductKeyValue(this.productIds[0], 'access')
            return access ? access.AccessLevel : 0
        }
    },
    methods: {
        ...mapActions('supplierProducts', ['updateProductsMass']),
        closeModal() {
            this.$emit('closeModal')
        },
        onProductVisibilityChange(val) {
            this.visibility = val
        },
        async saveModal() {
            // console.log('saveModal')

            if (this.loading) return

            this.loading = true

            let data = {
                AccessLevel: this.visibility || undefined, //if 0 not send
                Items: this.productIds
            }

            try {
                let payload = {
                    type: 'access',
                    data
                }
                await this.updateProductsMass(payload)

                this.$notify({
                    title: 'Видимость изделий изменена',
                    type: 'success'
                })

                this.$emit('onChangeVisibilityMassSaved')
            } catch (e) {
                console.log(e)
                this.$notify({
                    title: 'Ошибка',
                    type: 'error'
                })
            }

            this.loading = false
            this.closeModal()
        }
    }
}
</script>
